// eslint-disable-next-line import/no-anonymous-default-export
export default {
  app: {
    name: "ENCOO BACKGROUND",
  },
  edition: {
    enterprise: "Enterprise",
    community: "Community",
  },
  validate: {
    phone: "Please input correct phone number",
    fax: "Please input correct fax number",
    email: "please input correct email format",
    notEmpty: "Please provide content",
    image: "Please provide content",
    video: "Please provide content",
    guid: "Please provide content",
    password:
      "the value contains 8 to 16 characters and at least three of the following characters: uppercase, lowercase, digits, and special characters",
  },
  common: {
    deleteSuccessfully: "Delete Successfully",
    deleteFailed: "Delete Failed",
    editSuccessfully: "Update Successfully",
    editFailed: "Update Failed",
    reset: "Reset",
    searchName: "Search Name",
    email: "Email",
    loginSuccess: "Login successfully",
    loginOut: "Login Out",
    goBack: "Back",
    required: "The informatoin is required",
    emailValidation: "Please input correct email format",
    robot: "Robot",
    today: "Today",
    currentMonth: "This month",
    editor: "Editor",
    copy: "Copy",
    selectAll: "Select All",
    placeholder: "Please input",
    alertTitle: "Confirm",
    updataTime: "Update Time",
    unBind: "Unbound",
    bound: "Bound",
    nobound: "Not bound",
    unBound: "Unbound",
    packageName: "Package Name",
    create: "Create",
    multiControl: "Multiple opeartion",
    tag: "Tag",
    delete: "Delete",
    remove: "Remove",
    operation: "Action",
    upload: "Upload",
    resourceMove: "Resource group migration",
    processDeployment: "Deploy",
    status: "Status",
    note: "Description",
    view: "View",
    detail: "Detail",
    log: "Log",
    loading: "Loading...",
    phone: "Phone",
    download: "Download",
    upgrade: "Upgrade",
    cancel: "Cancel",
    edit: "Edit",
    complete: "Complete",
    type: "Type",
    createTime: "Creation Time",
    description: "Description",
    creationTime: "Creation Time",
    createdBy: "Created by ",
    close: "Close",
    confirm: "Yes",
    save: "Save",
    pleaseInput: "Please input",
    pleaseSelect: "Please select",
    robotName: "Robot Name",
    deleteConfirmation: "Confirm to delete",
    contact: "Contact {attrType}",
    name: "Name",
    baseConfig: "Setting",
    bindRobot: "Bound Robot",
    add: "Add",
    nextStep: "Next Step",
    preStep: "Previous Step",
    createSuccess: "Create successfully",
    uploadSuccess: "Upload successfully",
    config: " Configuration",
    bindWorkflow: "Bind workflow",
    empty: "Empty",
    null: "Null",
    home: "Homepage",
    yes: "Yes",
    no: "No",
    uploadFile: "Upload file",
    select: "Search",
    tip: "Tip",
    overdue:
      "Current login has expired, please click 'Confirm' to log in again!",

    issueOfPermit: "Issue of Permit",
    minimum: "Minimum",
    maximum: "Maximum",
    noPermission: "You do not have permission to access the system!",
    info: {
      createEntity: "Create {entityTypeName}",
      editEntity: "Modify {entityTypeName}",
      createSuccessfully: "Create {entityTypeName} {name} successfully",
      createFailed: "Create {entityTypeName} {name} failed",

      deletionConfirmation: "Are you sure to delete {entityTypeName} {name} ?",
      deletionFailed: "Delete {entityTypeName} {name} failed",
      deleteSuccessfully: "Delete {entityTypeName} {name} successfully",
      updateSuccessfully: "Update {entityTypeName} {name} successfully",
      updateFailed: "Update {entityTypeName} {name} failed",
      bindSuccessfully: "{name} is bound to {entityTypeName} successfully",
      unbindSuccessfully:
        "{name} is unbound from {entityTypeName}  successfully",
      bindFailed: "{name} is failed to bind to  {entityTypeName}",
      unbindFailed: "{name} is failed to bind to  {entityTypeName}",
    },
    createSuccessfully: "Create Successfully",
    createFailed: "Create Failed",
    copySuccessfully: "Copy Successfully",
    updateSuccessfully: "Update successfully",
    updateFailed: "Update failed",
    addSuccess: "Create An Account Successfully",
    addFailed:
      "Create failed, please confirm whether the form is filled in correctly and whether the current administrator account exists!",
    pleaseSelectTime: "Please choose time",
    startTime: "Start Time",
    endTime: "End Time",
    baseInfo: "Basic information",
    clickHere: "Click here",
  },
  week: {
    MON: "Monday",
    TUE: "Tuesday",
    WED: "Wednesday",
    THU: "Thursday",
    FRI: "Friday",
    SAT: "Saturday",
    SUN: "Sunday",
  },
  sku: {
    community: {
      normal: "Community Edition",
    },
    enterprise: {
      normal: "Enterprise Edition",
      basic: "Enterprise Basic Edition",
      senior: "Enterprise Senior Edition",
    },
  },
  environment: {
    uniqueCode: "Machine code",
  },
};
